import { useAuth } from '@/contexts/AuthContext';

export function useUser() {
  const { user, loading, signOut } = useAuth();

  return {
    user,
    loading,
    logout: signOut,
    isAuthenticated: !!user,
  };
}

export default useUser;
